// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69de4c5d","455":"960b43bb","946":"da0a3417"}[chunkId] + ".chunk.js";
};